import { Component, OnInit } from '@angular/core';
import { SimpleNotificationsComponent } from 'angular2-notifications';
import { ConfigService } from '../../../services/config.service';
import { RequestService } from '../../../services/request.service';
import { UtilService } from '../../../services/util.service';
import { SessionService } from '../../../services/session.service';

import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'itpx-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
    isLogged$: Observable<boolean>;
    // groups$: Observable<string[]>;

    instructorMarketUrl: string;

    year: number;
    baseUrl: string;
    saharaUrl: string;
    pmpUrl: string;
    isBuyer = false;
    isSeller = false;
    isInstructor = false;

    private logo: string;
    private domainConfigData = null;
    socialMediaLink = null;

    constructor(
        private configService: ConfigService, private authService: AuthService, private requestService: RequestService, private sessionService: SessionService, private router: Router
    ) {

        this.domainConfigData = this.configService.getDomainConfigData();
        this.logo = (
            this.domainConfigData &&
            this.domainConfigData.logo &&
            this.domainConfigData.logo.light &&
            this.domainConfigData.logo.light.url)
            ?
            this.domainConfigData.logo.light.url
            :
            this.configService.get('aws').downloadUrl + this.configService.get('images').newWhiteEdcastLogo;
        this.socialMediaLink = {
            "facebook": "https://www.facebook.com/EdCast",
            "twitter": "https://twitter.com/edcast",
            "instagram": "https://www.instagram.com/edcast_inc/",
            "linkedIn": "https://www.instagram.com/edcast_inc/"
        }
        if (this.domainConfigData && this.domainConfigData.socialMediaLink) {
            this.socialMediaLink = this.domainConfigData.socialMediaLink;
        }
    }

    ngOnInit() {
        this.year = new Date().getFullYear();
        this.saharaUrl = this.configService.get('server').sahara;

        this.instructorMarketUrl = this.configService.get('server').instructorMarket;
        this.pmpUrl = this.configService.get('server').productMarketplace;
        this.isLogged$ = this.authService.isAuthenticated$
        this.getSaharaVersion()
            .subscribe(
                body => {
                    // this.saharaVersion = body.data.version;
                    this.sessionService.setSaharaVersion(body.data.version);
                }
            );
        this.isLogged$.take(1).subscribe(isLogged => {
            if (isLogged) {
                this.isBuyer = this.sessionService.hasUserGroup('buyer') || this.sessionService.hasUserGroup('buyer-admin')
                this.isSeller = this.sessionService.hasUserGroup('seller') || this.sessionService.hasUserGroup('seller-admin')
                this.isInstructor = this.sessionService.hasUserGroup('instructor')
            }
        })


    }


    getSaharaVersion(): Observable<any> {
        let url = this.configService.get('server').sahara + this.configService.get('endpoints').sahara.other.version.api;
        return this.requestService.get(url);
    };

    login() {
        this.router.navigate(['/login'])
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/partials/footer/footer.component.ts